export class ProjectManagers {
  static selector = "[data-component=project-managers]"

  constructor(el) {
    this.root = el
    this.leftCol = this.root.querySelector("& > div:first-child")
    this.isMobile = window.getComputedStyle(this.root).getPropertyValue('--behavior') === "mobile"

    this.setup()
  }

  getEventPmLi = ev => ev.target.tagName === "LI" ? ev.target : ev.target.closest("li")

  setupLeftColImg = pmLi => {
    if (this.isMobile) {
      return
    }

    let leftColImg = this.leftCol.querySelector("img")
    if (!leftColImg) {
      leftColImg = document.createElement("img")
      leftColImg.classList.add("display--desktop")
      this.leftCol.appendChild(leftColImg)
    }
    leftColImg.classList.remove("display--none")
    leftColImg.src = pmLi.querySelector("img").src

    /* determine y coordinate for image to line up with selected li. idea is that top edges are
     * aligned, unless it's the very top (which would interfere with "our project management team",
     * so it goes below that), or would overflow the bottom, in which case bottom edges are aligned.
     */
    const
      rootRect = this.root.getBoundingClientRect(),
      liRect = pmLi.getBoundingClientRect(),
      // imgs are square, and if we're inserting for the first time it may not have been laid out
      // yet and won't have real dimensions, so we calculate expected height from col width
      imgHeight = this.leftCol.getBoundingClientRect().width,
      parentTopOffset = liRect.y - rootRect.y,
      minYOffset = this.leftCol.querySelector("p").getBoundingClientRect().height,
      parentBotOffset = rootRect.height - (parentTopOffset + liRect.height)

    if (parentTopOffset + imgHeight > rootRect.height) {
      leftColImg.style.setProperty("bottom", `${parentBotOffset}px`)
      leftColImg.style.removeProperty("top")
    } else {
      leftColImg.style.setProperty("top", `${Math.max(parentTopOffset, minYOffset)}px`)
      leftColImg.style.removeProperty("bottom")
    }
  }

  selectPm = ev => {
    const pmLi = this.getEventPmLi(ev)
    const prevSelected = this.root.querySelector("ul li[data-selected]")
    if (prevSelected) {
      prevSelected.removeAttribute("data-selected")
    }

    pmLi.setAttribute("data-selected", "")
    this.setupLeftColImg(pmLi)
  }

  deselectPm = ev => {
    const pmLi = this.getEventPmLi(ev)
    pmLi.removeAttribute("data-selected")

    const leftColImg = this.leftCol.querySelector("img")
    if (leftColImg) {
      leftColImg.classList.add("display--none")
    }
  }

  onClick = ev => {
    const pmLi = this.getEventPmLi(ev)
    if (pmLi.hasAttribute("data-selected")) {
      this.deselectPm(ev)
    } else {
      this.selectPm(ev)
    }
  }

  setup() {
    for (const pmLi of this.root.querySelectorAll("ul li")) {
      if (this.isMobile) {
        pmLi.addEventListener("click", this.onClick)
      } else {
        pmLi.addEventListener("mouseenter", this.selectPm)
        pmLi.addEventListener("mouseleave", this.deselectPm)
      }
    }
  }
}
